"use strict";

var _slicedToArray = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useDarkPreference = function useDarkPreference() {
  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      prefersDark = _ref2[0],
      setPrefersDark = _ref2[1];

  (0, react_1.useEffect)(function () {
    if (typeof window !== 'undefined' && window.matchMedia) {
      // function to check prefers-color-scheme query
      var checkPrefersDark = function checkPrefersDark() {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) setPrefersDark(true);else setPrefersDark(false);
      }; // run the check on mount


      checkPrefersDark(); // create our query

      var query = window.matchMedia('(prefers-color-scheme: dark)'); // attach event listener

      query.addEventListener('change', checkPrefersDark); // clean up event listener on component unmount

      return function () {
        return query.removeEventListener('change', checkPrefersDark);
      };
    }
  }, []);
  return prefersDark;
};

exports.default = useDarkPreference;